import useDriftClient from '../useDriftClient';
import { useMemo } from 'react';
import { ZERO, BigNum, QUOTE_PRECISION_EXP } from '@velocity-exchange/sdk';
import { useCurrentAccountPositions } from '../query/accountTradingData/usePositions';

export const useIsolatedPositionMargin = (marketIndex: number) => {
	const driftClient = useDriftClient();
	const perpPositions = useCurrentAccountPositions();
	const perpPositionUnsettledPnl = useMemo(
		() =>
			perpPositions?.find((o) => o.marketIndex === marketIndex)?.unsettledPnl,
		[perpPositions, marketIndex]
	);

	const isolatedDeposit = useMemo(() => {
		if (!driftClient?.hasUser()) return ZERO;
		try {
			const amount =
				driftClient.getIsolatedPerpPositionTokenAmount(marketIndex);
			return amount ?? ZERO;
		} catch (e: unknown) {
			console.error('Error getting isolated position margin', e);
			return ZERO;
		}
	}, [driftClient, marketIndex, perpPositions, perpPositionUnsettledPnl]);
	const isolatedMargin = isolatedDeposit.add(perpPositionUnsettledPnl ?? ZERO);

	const value = BigNum.from(isolatedMargin, QUOTE_PRECISION_EXP);

	return value;
};
